module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"NAVIGATOR.SK s.r.o.","short_name":"NAVIGATOR","start_url":"/","background_color":"#0f172a","theme_color":"#3b82f6","display":"minimal-ui","icon":"src/images/navigator-icon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"57bdb50ca98f1f972688ba71a738a239"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
